/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Locale_Banner_Settings_LinkInputs */



/**
* | output |
* | --- |
* | "Language settings" |
*
* @param {Locale_Banner_Settings_LinkInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const locale_banner_settings_link = /** @type {((inputs?: Locale_Banner_Settings_LinkInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Locale_Banner_Settings_LinkInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Spracheinstellungen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Paramètres de langue")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("语言设置")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("語言設定")
	if (locale === "ko") return /** @type {LocalizedString} */ ("언어 설정")
	return /** @type {LocalizedString} */ ("Language settings")
});